import React from 'react'
import { hurdles } from '../../content/csp'

const ApproachSection = () => {
  return (
    <section className="csp-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <span className="csp-kicker">What has to happen</span>
            <h2 className="csp-title">
              Three hurdles stand between a quiet center and a usable one.
            </h2>
            <p className="csp-lead">
              Our approach uses technology to help members talk, gather their
              opinions, and put those views in a format other moderate
              organizations and elected representatives can use.
            </p>
          </div>
        </div>
        <div className="csp-grid csp-grid--3" style={{ marginTop: 40 }}>
          {hurdles.map((hurdle, index) => (
            <article className="csp-card" key={hurdle.title}>
              <span className="csp-kicker">0{index + 1}</span>
              <h3>{hurdle.title}</h3>
              <p>{hurdle.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ApproachSection
